// extracted by mini-css-extract-plugin
export var table = "_uo-0";